import { convertDateRangeToDates } from "@wingspanhq/fe-component-library";
import { WorkLogStatus } from "@wingspanhq/payments/dist/interfaces";
import { ApiQueryListWorkLogs } from "../../../../../services/workLog";
import { UrlQuerySort } from "../../../../../shared/hooks/useUrlQuery";
import { getApiDirectionFromTable } from "../../../../../shared/utils/sorting";
import { Filter, SortField, WorkLogPayerTabFilterStatus } from "./types";

export function createListRequest(
  userId: string,
  filter?: Filter,
  sort?: UrlQuerySort<SortField>
): ApiQueryListWorkLogs {
  const request: ApiQueryListWorkLogs = {
    "filter[payerId]": userId,
    "sort[updatedAt]": getApiDirectionFromTable(sort?.direction) || "desc"
  };

  if (filter?.payeeId) {
    request["filter[payeeId]"] = filter.payeeId;
  }

  if (filter?.assignmentId) {
    request["filter[payerPayeeEngagementId][=]"] = filter.assignmentId;
  }

  // TODO: update status method with WorkLogStatus.[status] once backend is done, right now using it as WorkLogStatus
  // for pending enums on the backend

  // Status filtering based on backend WorkLogStatus enum
  if (filter?.status) {
    switch (filter.status) {
      case WorkLogPayerTabFilterStatus.ToApprove:
        // InReview - awaiting payer approval
        request["filter[status][=]"] = "InReview" as WorkLogStatus;
        break;
      case WorkLogPayerTabFilterStatus.InProgress:
        // InProgress - returned for payee corrections
        request["filter[status][=]"] = "InProgress" as WorkLogStatus;
        break;
      case WorkLogPayerTabFilterStatus.Approved:
        request["filter[status][=]"] = WorkLogStatus.Approved;
        break;
      case WorkLogPayerTabFilterStatus.Rejected:
        request["filter[status][=]"] = "Rejected" as WorkLogStatus;
        break;
    }
  }

  if (filter?.dateRange) {
    const dateRange = convertDateRangeToDates(filter.dateRange);
    if (dateRange) {
      request["filter[startDate][>]"] = dateRange.start;
      request["filter[startDate][<]"] = dateRange.end;
    }
  }

  return request;
}
